'NextNumber'.datatype()
'forDatatype'.field({key: true})
'number'.field({numeric: true})
